import { hasMessageButtons, hasCsatRatingTrigger } from '../../types/guards';
import type { Message } from '../../types/messages';
import { WebsocketMessageContentType } from '../../types/ws-events';

/**
 * Возвращает тип сообщения в виджете
 */
export const getMessageType = (message: Message) => {
  const { messageContentType } = message;

  const isChatMessage = [WebsocketMessageContentType.Text, WebsocketMessageContentType.Html].includes(
    messageContentType
  );

  const isCsatRequest = messageContentType === WebsocketMessageContentType.JsonCsatRequest;
  const isChatBotRequest = messageContentType === WebsocketMessageContentType.JsonChatBotRequest;

  const hasButtons = hasMessageButtons(message);

  const isCsatRatingRequest = isCsatRequest && hasCsatRatingTrigger(message);
  const isCsatReasonRequest = isCsatRequest && !hasCsatRatingTrigger(message);

  return {
    /** Сообщение в чате, ответ бота или агента, реплика пользователя */
    isChatMessage,
    /** Запрос причины оценки csat */
    isCsatReasonRequest,
    /** Запрос оценки csat */
    isCsatRatingRequest,
    /** Сообщение от бота с кнопками */
    isChatBotRequest,
    /** Наличие кнопок в сообщении */
    hasButtons,
  };
};
